import search from 'assets/icons/icon-search.svg?react';
import plus from 'assets/icons/icon-plus.svg?react';
import remove from 'assets/icons/icon-remove.svg?react';
import chevronUp from 'assets/icons/icon-chevron-up.svg?react';
import chevronRight from 'assets/icons/icon-chevron-right.svg?react';
import chevronLeft from 'assets/icons/icon-chevron-left.svg?react';
import chevronDown from 'assets/icons/icon-chevron-down.svg?react';

export interface iconsInterface {
  search: any,
  plus: any,
  remove: any,
  chevronUp: any,
  chevronDown: any,
  chevronLeft: any,
  chevronRight: any,
}

const icons: iconsInterface = {
  search,
  plus,
  remove,
  chevronUp,
  chevronDown,
  chevronLeft,
  chevronRight,
}

export default icons;
